import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-holiday-dialog',
  templateUrl: './holiday-dialog.component.html',
  styleUrls: ['./holiday-dialog.component.scss']
})
export class HolidayDialogComponent implements OnInit {
  selectedEventType: string = 'offline';
  
  constructor(
    public dialogRef: MatDialogRef<HolidayDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    // Initialize component
  }

  cancel(): void {
    this.dialogRef.close();
  }

  _addHoliday(holidayForm: NgForm): void {
    if (holidayForm.valid) {
      // Format the form data
      const formData = this.formatHolidayData(holidayForm.value);
      
      // Close dialog and return the form data
      this.dialogRef.close(formData);
    }
  }

  resetForm(holidayForm: NgForm): void {
    holidayForm.resetForm();
    this.selectedEventType = 'offline';
  }

  private formatHolidayData(formValue: any): any {
    // Format date
    let formattedDate = '';
    if (formValue.holidaydate) {
      const date = new Date(formValue.holidaydate);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      formattedDate = `${year}-${month}-${day}`;
    }

    // Base data for all holiday types
    const baseData = {
      date: formattedDate,
      name: formValue.holidayname,
      type: formValue.holidaytype
    };

    // Only add event-specific fields if holiday type is "Event" (value "3")
    if (formValue.holidaytype === '3') {
      return {
        ...baseData,
        desc: formValue.eventdescription || '',
        location: formValue.eventlocation || '',
        status: formValue.eventtype || '',
        start_time: formValue.eventstarttime || '',
        end_time: formValue.eventendtime || ''
      };
    }

    // For non-event holidays, don't include event-specific fields
    return baseData;
  }
}